import { createSlice } from "@reduxjs/toolkit";

// Try to load from localStorage on initial load
const loadFromLocalStorage = () => {
    try {
        const stored = localStorage.getItem("planLimits");
        if (stored) {
            return JSON.parse(stored);
        }
    } catch (error) {
    }
    return null;
};

const storedData = loadFromLocalStorage();

const initialState = {
    plan: storedData?.plan || null,
    limits: storedData?.limits || {
        users: 0,
        spaces: 0,
        requests: 0,
        datastorage: 0
    },
    isLoading: false,
    error: null,
    lastFetched: storedData?.lastFetched || null
};

const planSlice = createSlice({
    name: "plan",
    initialState,
    reducers: {
        setPlanDetails: (state, action) => {
            const { plan, features } = action.payload;
            state.plan = plan;
            
            // Parse features array into limits object
            if (features && Array.isArray(features)) {
                features.forEach(feature => {
                    if (feature.name && typeof feature.count === 'number') {
                        state.limits[feature.name] = feature.count;
                    }
                });
            }
            
            state.lastFetched = Date.now();
            
            // Persist to localStorage
            try {
                localStorage.setItem("planLimits", JSON.stringify({
                    plan: state.plan,
                    limits: state.limits,
                    lastFetched: state.lastFetched
                }));
            } catch (error) {
            }
        },
        setPlanLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setPlanError: (state, action) => {
            state.error = action.payload;
        },
        clearPlanDetails: (state) => {
            state.plan = null;
            state.limits = {
                users: 0,
                spaces: 0,
                requests: 0,
                datastorage: 0
            };
            state.isLoading = false;
            state.error = null;
            state.lastFetched = null;
            
            // Clear from localStorage
            try {
                localStorage.removeItem("planLimits");
            } catch (error) {
            }
        }
    }
});

export const {
    setPlanDetails,
    setPlanLoading,
    setPlanError,
    clearPlanDetails
} = planSlice.actions;

export default planSlice.reducer;
